/**
 * Build-time runtime configuration for the floor PWA, read once from the typed
 * `import.meta.env` (see vite-env.d.ts). No Entra values — this is a device app.
 */

/** WarehouseLogix API origin. Trailing slash is tolerated by the API client. */
export const API_BASE: string = import.meta.env.VITE_API_BASE;

/** This bundle's build id; drives the version-check refresh banner. */
export const BUILD_ID: string = import.meta.env.VITE_BUILD_ID;
